import { render } from "./EditRealEstate.vue?vue&type=template&id=0bf6ea17"
import script from "./EditRealEstate.vue?vue&type=script&lang=js"
export * from "./EditRealEstate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__